import { render } from "./driver-history.vue?vue&type=template&id=53f5619c&scoped=true"
import script from "./driver-history.vue?vue&type=script&lang=js"
export * from "./driver-history.vue?vue&type=script&lang=js"

import "./driver-history.vue?vue&type=style&index=0&id=53f5619c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f5619c"]])

export default __exports__